﻿$.fn.dxCtrlCmdImportInEmail = function custom_dxCtrlCmdImportInEmail(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcmdimportinemail dx-ctrl");
        this.createInstance(new cdxCtrlCmdImportInEmail(this, option));
    }
    return this;
}

window.cdxCtrlCmdImportInEmail = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()
        container.remove()
        if (option.lstPathName.length > 0) {
            var newPathName = option.lstPathName[0]
            option.bddCtrl.mAjaxCall({ command: "getdatafichieremlz", id_fichier: newPathName }, function (data) {
                var dataOriginal = option.onGetData()
                if (typeof data.lstfile == 'undefined') data.lstfile = []
                var changeObjet = true
                var viderFichier = true
                var ajouterFichier = true
                var remplacerToutHtml = true
                var $DivContent = $("<div/>")
                $("<div style='font-size:120%;padding-top:20px;'><b style='color:" + theme.backgroundcolorAccent + ";'>OBJET:</b></div>").appendTo($DivContent)
                if (dataOriginal.objet.length > 0) {
                    if (data.objet.length > 0) {
                        $("<div style='font-size:120%;'>Votre document actuel a pour objet:<br/><i style='font-size:80%;opacity:0.5;'>'" + dataOriginal.objet + "'</i></div>").appendTo($DivContent)
                        var ds1 = ["Remplacer l'objet de votre document par celui du document sélectionné<br/><i style='font-size:80%;opacity:0.5;'>'" + data.objet + "'</i>", "Laisser l'objet de votre document en l'état"]
                        $("<div style='padding-left:20px;'/>").appendTo($DivContent).dxCtrlRadioGroup({
                            dataSource: ds1,
                            focusStateEnabled: false,
                            itemTemplate: function (itemData, itemIndex, itemElement) {
                                itemElement.html(itemData)
                            },
                            value: ds1[0],
                            layout: 'vertical',
                            onValueChanged: function (e) { changeObjet = (ds1.indexOf(e.value) == 0) }
                        })
                    } else {
                        $("<div style='font-size:120%;'>Le document sélectionné n'a pas d'objet</div>").appendTo($DivContent)
                        var ds1 = ["Vider l'objet de votre document", "Laisser l'objet en l'état sur votre document"]
                        $("<div style='padding-left:20px;'/>").appendTo($DivContent).dxCtrlRadioGroup({
                            dataSource: ds1,
                            focusStateEnabled: false,
                            itemTemplate: function (itemData, itemIndex, itemElement) {
                                itemElement.html(itemData)
                            },
                            value: ds1[0],
                            layout: 'vertical',
                            onValueChanged: function (e) { changeObjet = (ds1.indexOf(e.value) == 0) }
                        })
                    }
                } else {
                    if (data.objet.length > 0) {
                        $("<div style='font-size:100%;'>L'objet <i style='font-size:80%;opacity:0.5;'>'" + data.objet + "'</i> du document sélectionné sera attribué à votre document</div>").appendTo($DivContent)
                    } else {
                        $("<div style='font-size:100%;'>Vos documents n'ont pas d'objet. Aucune modification d'objet.</div>").appendTo($DivContent)
                    }
                }
                $("<div style='font-size:120%;padding-top:20px;'><b style='color:" + theme.backgroundcolorAccent + ";'>FICHIERS JOINTS:</div>").appendTo($DivContent)
                if (dataOriginal.lstFile.length > 0) {
                    $("<div style='font-size:100%;'>Votre document actuel contient <b>" + dataOriginal.lstFile.length + "</b> fichier" + ((dataOriginal.lstFile.length > 1) ? "s" : "") + "</div>").appendTo($DivContent)
                    if (data.lstfile.length > 0) {
                        var ds2 = ["Remplacer les fichiers de votre document par ceux du document sélectionné (<b>" + data.lstfile.length + " fichier" + ((data.lstfile.length > 1) ? "s" : "") + "</b>)", "Garder les fichiers de votre document et rajouter ceux du document sélectionné (<b>" + (data.lstfile.length + dataOriginal.lstFile.length) + " fichier" + ((data.lstfile.length + dataOriginal.lstFile.length > 1) ? "s" : "") + "</b>)", "Laisser les fichiers joints en l'état sur votre document (<b>" + dataOriginal.lstFile.length + " fichier" + ((dataOriginal.lstFile.length > 1) ? "s" : "") + "</b>)"]
                        $("<div style='padding-left:20px;'/>").appendTo($DivContent).dxCtrlRadioGroup({
                            dataSource: ds2,
                            focusStateEnabled: false,
                            itemTemplate: function (itemData, itemIndex, itemElement) {
                                itemElement.html(itemData)
                            },
                            value: ds2[0],
                            layout: 'vertical',
                            onValueChanged: function (e) {
                                viderFichier = (ds2.indexOf(e.value) == 0)
                                ajouterFichier = (ds2.indexOf(e.value) == 0 || ds2.indexOf(e.value) == 1)
                            }
                        })
                    } else {
                        //$("<div style='font-size:120%;padding-top:20px;'><b style='color:" + theme.backgroundcolorAccent + ";'>FICHIERS JOINTS:</b> Le document n'a pas de fichiers joints</div>").appendTo($DivContent)
                        var ds2 = ["Vider les fichiers de votre document comme dans le document sélectionné", "Laisser les fichiers joints en l'état sur votre document (<b>" + dataOriginal.lstFile.length + " fichier" + ((dataOriginal.lstFile.length > 1) ? "s" : "") + "</b>)"]
                        $("<div style='padding-left:20px;'/>").appendTo($DivContent).dxCtrlRadioGroup({
                            dataSource: ds2,
                            focusStateEnabled: false,
                            itemTemplate: function (itemData, itemIndex, itemElement) {
                                itemElement.html(itemData)
                            },
                            value: ds2[0],
                            layout: 'vertical',
                            onValueChanged: function (e) {
                                viderFichier = (ds2.indexOf(e.value) == 0)
                            }
                        })
                    }
                } else {
                    if (data.lstfile.length > 0) {
                        $("<div>" + ((data.lstfile.length > 2) ? "Les <b>" + data.lstfile.length + " fichiers" : "Le <b>fichier") + "<b> du document sélectionné seront rajouté à votre document actuel.</div>").appendTo($DivContent)
                    } else {
                        $("<div style='font-size:100%;'>Vos documents n'ont pas de fichier joint. Aucune modification des fichiers joints.</div>").appendTo($DivContent)
                    }
                }

                //remplacer tout ou sélection
                $("<div style='font-size:120%;padding-top:20px;'><b style='color:" + theme.backgroundcolorAccent + ";'>CORPS DE VOTRE DOCUMENT:</div>").appendTo($DivContent)
                if (dataOriginal.text_body.trim().length > 0 && !dataOriginal.isAssistant && !(data.html.isAssistant())) {
                    var ds = ["Vider le corps de votre document et mettre le contenu du document sélectionné", "Insérez le contenu du document sélectionné à la place de la sélection dans votre document"]
                    $("<div style='padding-left:20px;'/>").appendTo($DivContent).dxCtrlRadioGroup({
                        dataSource: ds,
                        focusStateEnabled: false,
                        itemTemplate: function (itemData, itemIndex, itemElement) {
                            itemElement.html(itemData)
                        },
                        value: ds[0],
                        layout: 'vertical',
                        onValueChanged: function (e) { remplacerToutHtml = (ds.indexOf(e.value) == 0) }
                    })
                } else {
                    $("<div style=''>Le corps de votre document actuel sera remplacé par le corps du document sélectionné.</div>").appendTo($DivContent)
                    remplacerToutHtml = true
                }

                if ($DivContent.text().length > 0) {
                    var dxPopupInterne = $("<div/>").appendTo(option.container).dxCtrlPopupInterne({
                        bddCtrl: option.bddCtrl,
                        itemTemplate: function (contentElement) {
                            var $Div = $("<div style='font-size:200%;font-weight:bold;padding:15px;text-align:center;'>Intégrez un document email dans votre email</div>").appendTo(contentElement)
                            var obj = option.bddCtrl.getObjet({ id_fichier: newPathName })
                            var $Div = $("<div style='font-size:100%;padding:15px;text-align:center;'><b>Fichier sélectionné:</b><br/><div style='margin-top:5px;padding-top:5px;border:" + theme.border + ";'>" + obj.mGetLib1() + "</div><span style='opacity:0.2;'>" + obj.mGetLib2() + "</span></div>").appendTo(contentElement)
                            var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                            var $Tr = $("<tr/>").appendTo($Table)
                            var $Td = $("<td style='width:50%'/>").appendTo($Tr)
                            var $TdContainerAccordion = $("<td style='width:250px;min-width:380px;'/>").appendTo($Tr)
                            var $Td = $("<td style='width:50%'/>").appendTo($Tr)
                            $DivContent.appendTo($TdContainerAccordion)

                            $("<br/>").appendTo($TdContainerAccordion)
                            $("<div style='width:100%'/>").appendTo($TdContainerAccordion).dxCtrlButton({
                                text: "Valider",
                                width: "100%",
                                onClick: function (e) {
                                    option.onImport(data, changeObjet, viderFichier, ajouterFichier, remplacerToutHtml, function () {
                                        mNotify("Le document sélectionné a été importé dans votre document.", "success", 2000)
                                    })
                                    dxPopupInterne.mClose()
                                }
                            })
                        }
                    }).dxCtrlPopupInterne("instance")
                } else {
                    option.onImport(data, changeObjet, viderFichier, ajouterFichier, remplacerToutHtml, function () {
                        mNotify("Le document sélectionné a été importé dans votre document.", "success", 2000)
                    })
                }
            })
        }
    }

    this.element = function () { return container }

    mConstruit();
}